import { useState } from "react"
import { Div } from "./html"
import { ModelXform } from "./logic"
import { IChain, IModule } from "./model"
import { ChannelPort, IArch } from "./arch"

export function CollapsingJson ({chain,arch}:{chain:IChain,arch:IArch}) {
    const [collapsed, setCollapsed] = useState(true)
    const toggleCollapse = () => setCollapsed(!collapsed)
    const view = ModelXform({chain,arch})
        .lanes
        .map(lane => {
            return lane.cells
            .map(c => Object.entries(c)
                .filter(([k]) => k !== 'chain')
                .reduce((p,[k,v]) => {
                    // REDUCE modules to id+name
                    if (k === 'modules') {
                        p['modules'] =
                                Object.entries(v as Map<string,any>)
                                .reduce((p,[k,v]) => {
                                    if (['L','R'].includes(k) && v) {
                                        const module = v as IModule
                                        p[k] = [module].map(({id,name,device,channels,mono,stereo,m2s}) => ({
                                            id,
                                            name,
                                            device,
                                            channels: channels.map(({port}) => ChannelPort.toPortId(port,arch) ?? '❌').join(':'),
                                            mono,
                                            stereo,
                                            m2s,
                                        }))[0]
                                    }
                                    else if (k === 'split') {
                                        p[k] = v
                                    }
                                    return p
                                },{})
                    }
                    else if (k === 'm2s' || k === 'upM2S') {
                        p[k] = v?.id
                    }
                    else {
                        p[k] = v
                    }
                    return p
                },{}))})

    const storage = {
        chain: {
            id: chain.id,
            cond: chain.cond,
            state: chain.state,
        },
        lanes: chain.lanes
            .map(lane => lane.cells
                .map(c => Object.entries(c)
                    .reduce((p,[k,v]) => {
                        if (k === 'items' && Array.isArray(v)) {
                            p['items'] =
                                v.map(
                                    item => Object.entries(item as Map<string,any>)
                                    .reduce((p,[k,v]) => {
                                        if (['L','R'].includes(k) && v) {
                                            const module = v as IModule
                                            p[k] = [module].map(({id,name,midi,device,channels,mono,stereo,m2s}) => ({
                                                id,
                                                name,
                                                midi,
                                                device,
                                                channels,
                                                //channels: channels?.map(({label}) => label).join(':'),
                                                mono,
                                                stereo,
                                                m2s,
                                            }))[0]
                                        }
                                        else if (k === 'split') {
                                            p[k] = v
                                        }
                                        return p
                                    },{})
                                )
                        }
                        else {
                            p[k] = v
                        }
                        return p
                    },{})))
    }

    return (
        <Div s={{fs:8}} k="bg-gray">
            <button onClick={toggleCollapse}>{!collapsed && 'Hide '}JSON</button>
            {!collapsed && <pre style={{color:"black",backgroundColor:"white",fontSize:10}}>
                <br/>************************************************************* <br/>
                  STORAGE MODEL
                <br/>************************************************************* <br/>
                {JSON.stringify(storage,null,2)}
                <br/>
                <br/>************************************************************* <br/>
                  VIEW MODEL
                <br/>************************************************************* <br/>
                {JSON.stringify(view,null,2)}
            </pre>}
        </Div>
    )
}
